import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {
    ICommunityReportTemplateIncoming
} from "../../../models/community/report/template/ICommunityReportTemplateIncoming";
import {
    ICommunityReportTemplateOverviewIncoming
} from "../../../models/community/report/template/ICommunityReportTemplateOverviewIncoming";
import {
    ICommunityReportTemplateUpdateOutgoing
} from "../../../models/community/report/template/ICommunityReportTemplateUpdateOutgoing";

export class CommunityReportTemplateService {

    public static dispose(): void {
    }

    public static init(): void {
    }

    public static async list(communityId: string, component?: INetworkComponent): Promise<ICommunityReportTemplateOverviewIncoming[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/report-template/list/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getById(templateId: string, component?: INetworkComponent): Promise<ICommunityReportTemplateIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/report-template/${templateId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async create(communityId: string, component?: INetworkComponent): Promise<ICommunityReportTemplateIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/report-template/${communityId}`, {}, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async duplicate(templateId: string, component?: INetworkComponent): Promise<ICommunityReportTemplateIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/report-template/${templateId}/duplicate`, {}, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async update(data: ICommunityReportTemplateUpdateOutgoing, component?: INetworkComponent): Promise<ICommunityReportTemplateIncoming> {
        let request = await Network.putJson(ProductType.COMMUNITY, `/community/report-template`, data, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async delete(templateId: string, component?: INetworkComponent): Promise<void> {
        await Network.delete(ProductType.COMMUNITY, `/community/report-template/${templateId}`, component);
    }
}
